import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import { Grid, Tabs, Tab } from '@material-ui/core';

import GuideGeneralTab from './GuideGeneralTab';
import GuidesRulesTab from './GuidesRulesTab';

const styles = (theme) => ({
    tabs: {
        marginBottom: theme.typography.pxToRem(35),
    },
    tab: {
        paddingRight: theme.typography.pxToRem(30),
        paddingLeft: theme.typography.pxToRem(30),
        [theme.breakpoints.between('xs', 'md')]: {
            paddingRight: theme.typography.pxToRem(0),
            paddingLeft: theme.typography.pxToRem(0),
        },
    },
});

const TAB_TYPE = {
    GENERAL_TAB: 'general',
    RULES_TAB: 'rules',
};

const EditGuideFormGeneralTabs = ({
    classes,
    tabOpened,
    onTabChange,
    form,
    guide,
    initialValues,
}): React.ReactElement => {
    const tabIndexToTabType = (i) => {
        switch (i) {
            case 0:
                return TAB_TYPE.RULES_TAB;
            case 1:
                return TAB_TYPE.GENERAL_TAB;
            default:
                return null;
        }
    };

    const tabType = tabIndexToTabType(tabOpened);

    return (
        <Grid id="yeself-edit-guide-tabs-wrapper" container>
            <Tabs
                id="yeself-guide-tabs"
                value={tabOpened}
                indicatorColor="primary"
                textColor="primary"
                onChange={onTabChange}
                className={classes.tabs}
            >
                <Tab
                    id="yeself-guide-tab-rules"
                    disableRipple
                    label={<FormattedMessage id="Guides.rules" defaultMessage="Rules" />}
                />
                <Tab
                    id="yeself-guide-tab-general"
                    disableRipple
                    label={<FormattedMessage id="Guides.general" defaultMessage="General" />}
                />
            </Tabs>

            {tabType === TAB_TYPE.RULES_TAB && (
                <GuidesRulesTab form={form} guide={guide} className={classes.tab} isEditMode />
            )}

            {tabType === TAB_TYPE.GENERAL_TAB && (
                <GuideGeneralTab form={form} guide={guide} initialValues={initialValues} />
            )}
        </Grid>
    );
};

export default withStyles(styles)(EditGuideFormGeneralTabs);
